(function () {
  function initSizingHelp(root) {
    if (root.dataset.sizingInit === '1') return;
    root.dataset.sizingInit = '1';

    root.querySelectorAll('.sizing-help__tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var chart = tab.getAttribute('data-chart');
        root.querySelectorAll('.sizing-help__tab').forEach(function (btn) {
          btn.classList.toggle('is-active', btn === tab);
        });
        root.querySelectorAll('[data-chart-panel]').forEach(function (panel) {
          panel.classList.toggle('hide', panel.getAttribute('data-chart-panel') !== chart);
        });
      });
    });

    root.querySelectorAll('.sizing-help__unit').forEach(function (button) {
      button.addEventListener('click', function () {
        var unit = button.getAttribute('data-unit');
        root.querySelectorAll('.sizing-help__unit').forEach(function (btn) {
          var active = btn === button;
          btn.classList.toggle('is-active', active);
          btn.classList.toggle('active-unit', active);
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        root.classList.toggle('is-in', unit === 'in');
      });
    });
  }

  var bodyScrollLockY = 0;
  var delegated = false;

  function resolveModal(wrapper) {
    if (!wrapper) return null;
    var modal = wrapper.querySelector('[data-size-guide-modal]');
    if (!modal && wrapper.id) {
      modal = document.querySelector(
        '[data-size-guide-modal][data-guide-owner="' + wrapper.id + '"]'
      );
    }
    if (!modal) {
      var controls = wrapper.querySelector('[data-size-guide-open]');
      var modalId = controls && controls.getAttribute('aria-controls');
      if (modalId) modal = document.getElementById(modalId);
    }
    return modal;
  }

  function portalModalToBody(modal, wrapper) {
    if (!modal || !wrapper) return;
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    modal.dataset.portaled = '1';
    modal.dataset.guideOwner = wrapper.id;
    modal.classList.add('size-guide__modal--portaled');
  }

  function lockBodyScroll() {
    bodyScrollLockY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = '-' + bodyScrollLockY + 'px';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.classList.add('size-guide-open');
  }

  function unlockBodyScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.classList.remove('size-guide-open');
    window.scrollTo(0, bodyScrollLockY);
  }

  function closeModal(modal, openBtn) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.classList.add('is-closing');
    window.setTimeout(function () {
      modal.hidden = true;
      modal.classList.remove('is-closing');
      unlockBodyScroll();
      if (openBtn && typeof openBtn.focus === 'function') openBtn.focus();
    }, 280);
  }

  function openModal(wrapper) {
    var modal = resolveModal(wrapper);
    if (!modal) return;
    portalModalToBody(modal, wrapper);
    var closeBtn = modal.querySelector('[data-size-guide-close]');
    var sizingRoot = modal.querySelector('.sizing-help');
    if (sizingRoot) initSizingHelp(sizingRoot);
    modal.hidden = false;
    modal.classList.remove('is-closing');
    lockBodyScroll();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });
    });
    if (closeBtn) closeBtn.focus();
    modal._closeModal = function () {
      closeModal(modal, wrapper.querySelector('[data-size-guide-open]'));
    };
  }

  function bindDelegation() {
    if (delegated) return;
    delegated = true;

    window.addEventListener('click', function (event) {
      var openBtn = event.target.closest && event.target.closest('[data-size-guide-open]');
      if (openBtn) {
        event.preventDefault();
        event.stopPropagation();
        var wrapper = openBtn.closest('.size-guide');
        if (wrapper) openModal(wrapper);
        return;
      }

      var closeBtn = event.target.closest && event.target.closest('[data-size-guide-close]');
      if (closeBtn) {
        var modal = closeBtn.closest('[data-size-guide-modal]');
        if (modal) closeModal(modal, document.querySelector('[data-size-guide-open]'));
        return;
      }

      var overlay = event.target;
      if (overlay && overlay.matches && overlay.matches('[data-size-guide-modal]')) {
        closeModal(overlay, document.querySelector('[data-size-guide-open]'));
      }
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-size-guide-modal]:not([hidden])').forEach(function (modal) {
        closeModal(modal, document.querySelector('[data-size-guide-open]'));
      });
    });
  }

  function portalExisting() {
    document.querySelectorAll('.size-guide').forEach(function (wrapper) {
      var modal = resolveModal(wrapper);
      if (modal) portalModalToBody(modal, wrapper);
    });
    document.querySelectorAll('.sizing-help').forEach(function (root) {
      if (!root.closest('.size-guide')) initSizingHelp(root);
    });
  }

  bindDelegation();
  document.addEventListener('DOMContentLoaded', portalExisting);
  document.addEventListener('shopify:section:load', portalExisting);
  if (document.readyState !== 'loading') portalExisting();
})();
